import { apiService } from '@/services/APIService';

export default {

  defaultEmailSettings(params) {
    return apiService.getCached('/lists/default-email-setting', params);
  },

  webinarScheduleTypes(params) {
    return apiService.getCached('/lists/webinar-schedule-types', params);
  },

};
